"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("./state"));
var guide_1 = require("../models/guide");
var sheet_1 = __importStar(require("../views/sheet"));
var game_area_1 = require("../utilities/game-area");
var stack_container_1 = __importStar(require("../views/stack-container"));
var color_1 = require("../utilities/color");
var gsap_1 = require("gsap");
var PixiPlugin_1 = require("gsap/PixiPlugin");
gsap_1.gsap.registerPlugin(PixiPlugin_1.PixiPlugin);
PixiPlugin_1.PixiPlugin.registerPIXI(PIXI);
var GUIDE_MESSAGE_MAX_WIDTH = 205;
var GuideState = /** @class */ (function (_super) {
    __extends(GuideState, _super);
    function GuideState(app, client, guide, backdropContainer, dragonContainer) {
        var _this = _super.call(this) || this;
        _this._app = app;
        _this._client = client;
        _this._guide = guide;
        _this._backdropContainer = backdropContainer;
        _this._dragonContainer = dragonContainer;
        return _this;
    }
    Object.defineProperty(GuideState.prototype, "sheet", {
        get: function () {
            if (!this._sheet) {
                this._sheet = new sheet_1.default(this._app.loader.resources.ui.textures, sheet_1.SHEET_TYPE.DARK);
                this._sheet.contentContainer.addChild(this.stackContainer);
            }
            return this._sheet;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GuideState.prototype, "avatarSprite", {
        get: function () {
            if (!this._avatarSprite) {
                var texture = this._app.loader.resources.ui.textures["guide_avatar.png"];
                this._avatarSprite = new PIXI.Sprite(texture);
            }
            return this._avatarSprite;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GuideState.prototype, "messagesContainer", {
        get: function () {
            if (!this._messagesContainer) {
                this._messagesContainer = new stack_container_1.default([], {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.LEADING,
                    spacing: 20,
                    minWidth: GUIDE_MESSAGE_MAX_WIDTH
                });
            }
            return this._messagesContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GuideState.prototype, "nextIndicator", {
        get: function () {
            if (!this._nextIndicator) {
                var texture = this._app.loader.resources.ui.textures["guide_next.png"];
                this._nextIndicator = new PIXI.Sprite(texture);
            }
            return this._nextIndicator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GuideState.prototype, "stackContainer", {
        get: function () {
            if (!this._stackContainer) {
                this._stackContainer = new stack_container_1.default([
                    new stack_container_1.default([
                        this.avatarSprite,
                        this.messagesContainer
                    ], {
                        axis: stack_container_1.STACK_CONTAINER_AXIS.HORIZONTAL,
                        alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.TRAILING,
                        spacing: 20,
                    }),
                    this.nextIndicator
                ], {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 20,
                    minWidth: game_area_1.GAME_WIDTH
                });
            }
            return this._stackContainer;
        },
        enumerable: false,
        configurable: true
    });
    GuideState.prototype.didEnterFrom = function (previousState) {
        _super.prototype.didEnterFrom.call(this, previousState);
        this._app.stage.addChild(this._backdropContainer);
        this._app.stage.addChild(this.sheet);
        this._app.stage.interactive = true;
        this._app.stage.on("pointerdown", this.onNextPage.bind(this));
        this._dragonContainer.setIdleAnimation();
        this._backdropContainer.dragonSlot.addChild(this._dragonContainer);
        this.showSheet();
        this._client.sendEvent("guide_entered");
    };
    GuideState.prototype.willExitTo = function (nextState) {
        _super.prototype.willExitTo.call(this, nextState);
        this._app.stage.removeChild(this._backdropContainer);
        this._app.stage.removeChild(this.sheet);
        this._app.stage.interactive = false;
        this._app.stage.off("pointerdown");
        this._backdropContainer.dragonSlot.removeChild(this._dragonContainer);
    };
    GuideState.prototype.tipLabel = function (text) {
        var label = new PIXI.Text(text);
        label.style = {
            fontFamily: "Arial",
            fontSize: 21,
            fill: color_1.COLOR.WHITE
        };
        return label;
    };
    GuideState.prototype.showSheet = function () {
        this.setPage(0, 0.4);
        this.sheet.show(false, false);
        this.sheet.show(true, true);
    };
    GuideState.prototype.hideSheet = function () {
        var _this = this;
        this.sheet.show(false, true, function () {
            var _a, _b;
            _this.stateMachine.pop();
            (_b = (_a = _this._guide).onCompleted) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
    };
    GuideState.prototype.onNextPage = function () {
        if (this._currentPage == this._guide.pages.length - 1) {
            this.hideSheet();
            return;
        }
        this.setPage(this._currentPage + 1);
        this.sheet.show(true, false);
    };
    GuideState.prototype.isValidPage = function (page) {
        return page >= 0 && page <= this._guide.pages.length - 1;
    };
    GuideState.prototype.setPage = function (page, delay) {
        if (delay === void 0) { delay = 0; }
        if (!this.isValidPage(page)) {
            return;
        }
        this._currentPage = page;
        this.updateMessages();
        for (var i = 0; i < this.messagesContainer.children.length; i++) {
            var label = this.messagesContainer.children[i];
            gsap_1.gsap.fromTo(label, {
                y: label.y + 20,
                alpha: 0
            }, {
                y: label.y,
                alpha: 1,
                delay: 0.4 * i + delay,
                duration: 0.5,
                ease: "Power1.easeInOut"
            });
        }
    };
    GuideState.prototype.updateMessages = function () {
        var e_1, _a;
        var messages = this._guide.pages[this._currentPage];
        var labels = [];
        try {
            for (var messages_1 = __values(messages), messages_1_1 = messages_1.next(); !messages_1_1.done; messages_1_1 = messages_1.next()) {
                var message = messages_1_1.value;
                if (!message) {
                    continue;
                }
                var label = new PIXI.Text(message.text);
                switch (message.type) {
                    case guide_1.GUIDE_MESSAGE_TYPE.IMPORTANT:
                        label.style = {
                            fontFamily: "Arial",
                            fontWeight: "bold",
                            fontStyle: "italic",
                            fontSize: 35,
                            fill: color_1.COLOR.GREEN,
                            maxLineWidth: GUIDE_MESSAGE_MAX_WIDTH
                        };
                        break;
                    case guide_1.GUIDE_MESSAGE_TYPE.BONUS:
                        label.style = {
                            fontFamily: "Arial",
                            fontStyle: "italic",
                            fontSize: 18,
                            fill: color_1.COLOR.LIGHT_YELLOW,
                            wordWrap: true,
                            wordWrapWidth: GUIDE_MESSAGE_MAX_WIDTH
                        };
                        break;
                    default:
                        label.style = {
                            fontFamily: "Arial",
                            fontStyle: "italic",
                            fontSize: 18,
                            fill: color_1.COLOR.WHITE,
                            wordWrap: true,
                            wordWrapWidth: GUIDE_MESSAGE_MAX_WIDTH
                        };
                        break;
                }
                labels.push(label);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (messages_1_1 && !messages_1_1.done && (_a = messages_1.return)) _a.call(messages_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.messagesContainer.arrangedChildren = labels;
        this.stackContainer.layoutChildren();
    };
    return GuideState;
}(state_1.default));
exports.default = GuideState;
